<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <!-- Breadcrumb Navigation -->
      <nav
        class="d-flex align-items-center flex-wrap gap-2 mb-3"
        aria-label="breadcrumb"
      >
        <a
          class="back-link d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
          routerLink="/applicationConfiguration"
          [title]="'COMMON.BACK' | translate"
          (click)="goBack()"
        >
          <mat-icon class="text-primary">arrow_back</mat-icon>
        </a>

        <div class="d-flex align-items-center">
          <mat-icon class="me-3" color="primary">send</mat-icon>
          <p class="fw-semibold mb-0" style="font-size: 20px">
            {{
              "EMAIL_CONFIGURATION.Compose_Test_Email.Test_Email_Send"
                | translate
            }}
          </p>
        </div>

        <span class="text-secondary mx-2">/</span>
        <span class="text-secondary">{{
          "EMAIL_CONFIGURATION.Compose_Test_Email.Send_Test_Message" | translate
        }}</span>
      </nav>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <!-- Card Header -->
        <div class="card-header p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap gap-3"
          >
            <div>
              <h5 class="mb-1 d-flex align-items-center text-muted">
                <mat-icon class="me-3">mail_outline</mat-icon>
                <span>{{
                  "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Compose_Test"
                    | translate
                }}</span>
              </h5>
              <p class="text-muted small mb-0">
                {{
                  "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Server_Configuration_Title"
                    | translate
                }}
              </p>
            </div>
          </div>
        </div>

        <!-- Alerts -->
        <app-ncs-alert
          *ngIf="form['message']"
          [message]="form['message']"
          class="m-3"
          [type]="form['error'] ? 'danger' : 'success'"
        >
        </app-ncs-alert>

        <!-- Form Body -->
        <div class="card-body">
          <form #emailForm="ngForm">
            <div class="row g-3">
              <!-- Section: Message -->
              <div class="col-12">
                <h6
                  class="fw-semibold text-primary mb-0 d-flex align-items-center"
                >
                  {{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Message"
                      | translate
                  }}
                </h6>
              </div>

              <!-- From Email -->
              <div class="col-md-6">
                <label class="form-label fw-semibold text-secondary mb-2">
                  <i class="bx bi bi-terminal-plus me-1 text-primary"></i>
                  {{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.From"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    id="fromEmail"
                    name="fromEmail"
                    [(ngModel)]="testemail.data.fromEmail"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.From'
                        | translate
                    }}"
                    required
                  >
                    <mat-option
                      *ngFor="let email of emailOptions"
                      [value]="email"
                    >
                      {{ email }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- To Email -->
              <div class="col-md-6">
                <label class="form-label fw-semibold text-secondary mb-2">
                  <i class="bx bx-send me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.To"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="toEmail"
                    name="toEmail"
                    type="email"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Enter_To_Email'
                        | translate
                    }}"
                    [(ngModel)]="testemail.data.toEmail"
                    required
                  />
                  <mat-icon
                    matSuffix
                    class="icon-pd-none text-secondary icon-compact"
                    >email</mat-icon
                  >
                </mat-form-field>
              </div>

              <!-- CC -->
              <div class="col-md-6">
                <label class="form-label fw-semibold text-secondary mb-2">
                  <i class="bx bx-copy me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.CC"
                      | translate
                  }}
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="ccEmail"
                    name="ccEmail"
                    type="email"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Enter_CC_Email'
                        | translate
                    }}"
                    [(ngModel)]="testemail.data.ccEmail"
                  />
                  <mat-icon
                    matSuffix
                    class="icon-pd-none text-secondary icon-compact"
                    >email</mat-icon
                  >
                </mat-form-field>
              </div>

              <!-- BCC -->
              <div class="col-md-6">
                <label class="form-label fw-semibold text-secondary mb-2">
                  <i class="bx bx-low-vision me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.BCC"
                      | translate
                  }}
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="bccEmail"
                    name="bccEmail"
                    type="email"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Enter_BCC_Email'
                        | translate
                    }}"
                    [(ngModel)]="testemail.data.bccEmail"
                  />
                  <mat-icon
                    matSuffix
                    class="icon-pd-none text-secondary icon-compact"
                    >email</mat-icon
                  >
                </mat-form-field>
              </div>

              <!-- Divider -->
              <div class="col-12"><mat-divider class="my-3"></mat-divider></div>

              <!-- Subject -->
              <div class="col-12">
                <label class="form-label fw-semibold text-secondary mb-2">
                  <i class="bx bx-message-detail me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Subject"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="subject"
                    name="subject"
                    type="text"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Subject_Enter'
                        | translate
                    }}"
                    [(ngModel)]="testemail.data.subject"
                    required
                  />
                  <mat-hint>
                    <mat-icon
                      class="text-secondary"
                      style="font-size: 14px; vertical-align: middle"
                      >info</mat-icon
                    >
                    {{
                      "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Not_Required"
                        | translate
                    }}
                  </mat-hint>
                </mat-form-field>
              </div>

              <!-- Message Body -->
              <div class="col-12">
                <label class="form-label fw-semibold text-secondary mb-2">
                  <i class="bx bx-envelope-open me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Message"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea
                    matInput
                    id="message"
                    name="message"
                    rows="4"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Enter_Mail_Body'
                        | translate
                    }}"
                    [(ngModel)]="testemail.data.message"
                    required
                  ></textarea>
                  <mat-hint>
                    <mat-icon
                      class="text-secondary"
                      style="font-size: 14px; vertical-align: middle"
                      >info</mat-icon
                    >
                    {{
                      "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Not_Required"
                        | translate
                    }}
                  </mat-hint>
                </mat-form-field>
              </div>

              <!-- Send Buttons -->
              <div class="col-12">
                <div class="d-flex justify-content-end gap-3 py-3">
                  <button
                    type="button"
                    mat-raised-button
                    color="primary"
                    (click)="sendMailWithoutTemplate(emailForm)"
                  >
                    <mat-icon>send</mat-icon>
                    {{
                      "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Send"
                        | translate
                    }}
                  </button>

                  <button
                    type="button"
                    mat-raised-button
                    color="primary"
                    (click)="sendEmailQueue(emailForm)"
                  >
                    <mat-icon>queue</mat-icon>
                    {{
                      "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Send_Queue"
                        | translate
                    }}
                  </button>
                </div>
              </div>

              <!-- Divider -->
              <div class="col-12"><mat-divider class="my-3"></mat-divider></div>

              <!-- Section: Template -->
              <div class="col-12">
                <h6
                  class="fw-semibold text-primary mb-1 d-flex align-items-center"
                >
                  {{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Template"
                      | translate
                  }}
                </h6>
              </div>

              <!-- Template Select -->
              <div class="col-md-6">
                <label class="form-label fw-semibold text-secondary mb-2">
                  <i class="bx bx-file me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Template"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    id="template"
                    name="template"
                    [(ngModel)]="testemail.data.template"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Select_Template'
                        | translate
                    }}"
                    required
                  >
                    <mat-option
                      *ngFor="let template of templateOptions"
                      [value]="template"
                    >
                      {{ template.subject }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>

        <!-- Card Footer -->
        <div class="card-footer mt-3 bg-transparent">
          <div class="d-flex justify-content-end gap-3 py-3">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="sendMailWithTemplate(emailForm)"
            >
              <mat-icon>send</mat-icon>
              {{
                "EMAIL_CONFIGURATION.Compose_Test_Email.Compose_Test_Emails.Form.Send_With_Template"
                  | translate
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
